import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_EMAIL, LOGO_ALT, LOGO_URL } from '../data/site';
export function SiteFooter() {
  return <footer className="border-t border-ink-200 bg-paper" data-id="element-65" data-mp="3r917eewycj4l">
      <div className="mx-auto max-w-6xl px-6 py-14 lg:px-10" data-id="element-66" data-mp="3mgrfitca18zo">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]" data-id="element-67" data-mp="3hig3cbyiemea">
          <div data-id="element-68" data-mp="3hi6amgm2y14w">
            <div className="flex h-20 items-center overflow-hidden" data-id="element-69" data-mp="3hgdc5olmen7z">
              <img src={LOGO_URL} alt={LOGO_ALT} width={1372} height={470} className="-ml-[30px] h-[168px] w-auto shrink-0 mix-blend-multiply" data-id="element-70" data-mp="3difpasfbod7r" />
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-ink-500" data-id="element-71" data-mp="2yju12tr9ap8s">
              Advanced software development and applied research for teams working at the limits of
              what current technology can do.
            </p>
          </div>

          <nav aria-label="Footer" data-id="element-72" data-mp="wt0ehmiup7ra">
            <p className="text-[11px] uppercase tracking-label text-ink-500" data-id="element-73" data-mp="15r50iu5uh2o2">Sections</p>
            <ul className="mt-4 space-y-2.5 text-sm" data-id="element-74" data-mp="1apye0ml4sto8">
              {[{
              to: '/services',
              label: 'Services'
            }, {
              to: '/research',
              label: 'Research'
            }, {
              to: '/people',
              label: 'People'
            }, {
              to: '/contact',
              label: 'Contact'
            }].map(link => <li key={link.to} data-id="element-75" data-mp="1ogtilmolkom0">
                  <Link to={link.to} className="text-ink-700 transition-colors duration-150 ease-out hover:text-accent" data-id="element-76" data-mp="1ohv2mgnlclfv">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-77" data-mp="1jotm647qkdu6">
            <p className="text-[11px] uppercase tracking-label text-ink-500" data-id="element-78" data-mp="1joa2ahyizfdi">Inquiries</p>
            <a href={`mailto:${CONTACT_EMAIL}`} className="mt-4 inline-block text-sm text-accent underline decoration-accent/40 decoration-1 underline-offset-4 transition-colors duration-150 ease-out hover:text-accent-hover hover:decoration-accent" data-id="element-79" data-mp="27e4ecxb0szwp">
              {CONTACT_EMAIL}
            </a>
            <p className="mt-3 text-sm leading-relaxed text-ink-500" data-id="element-80" data-mp="2d1zmpoapnewx">
              Describe the problem. We will tell you honestly whether we are the right group for it.
            </p>
          </div>
        </div>

        <p className="mt-14 border-t border-ink-100 pt-6 text-xs text-ink-500" data-id="element-81" data-mp="234blcfiln95s">
          © {new Date().getFullYear()} Research Science Group. All rights reserved.
        </p>
      </div>
    </footer>;
}